<div class="pricy-notice">
  <span>S&Pグローバル・マーケット・インテリジェンスプライバシー通知</span>
</div>
<div class="col-xs-12 privacy-content">

  <div>
    <p><strong>S&Pグローバル・マーケット・インテリジェンスが資本市場の専門家向けリソースにお客様のビジネス連絡先情報を掲載</strong></p>
  </div>

  <div>
    <p>S&Pグローバル・マーケット・インテリジェンス（S&P Global Market Intelligence、S&Pグローバル（S&P Global,
      Inc.）の一部門）（以下「<strong>SPGI</strong>」）は、お客様のビジネス上の連絡先情報（氏名、役職および／または職務、ビジネス用電話番号、ビジネス用郵便宛先、ビジネス用メールアドレスなど）
      および本プライバシーに関する通知の「<strong>収集および処理される情報について</strong>」のセクションに記載されているその他の情報（「<strong>情報</strong>」）を、グローバル資本市場コミュニティのお客様の取引先、お客様、および/または以下の「<strong>お客様のビジネス連絡先情報の収集および使用方法</strong>」セクションに記載されているその他の情報源を含む複数のソースから収集し、グローバル資本市場コミュニティにおける弊社の包括的な連絡先リソースに含めるために利用します。
    </p>
  </div>

  <h3 class="privacy-h3">S&Pグローバル・マーケット・インテリジェンスのデータについて </h3>

  <div>
    <p>
      S&Pグローバル・マーケット・インテリジェンスにより、投資家や資本市場の専門家が、特定の金融機会に関連する情報を受け取る適切な受信者を特定するのに役立ち、市場でより効率的にビジネスを行うことを可能にします。資本市場の専門家は、弊社のリソースで情報を便利に利用できることから大きな恩恵を受けています。
    </p>
    <p>
      データの主な目的は、S&Pグローバル・マーケット・インテリジェンスのお客様に、グローバル資本市場コミュニティにおける個人および企業（「資本市場参加者」）に関する総合的なリソースを提供することであり、お客様は、それらの連絡先との関連のある企業間コミュニケーションおよび情報交換（以下「お客様の情報の共有方法」を参照）を円滑に行うために、また、S&Pグローバル・マーケット・インテリジェンスの商品およびサービスのマーケティング（以下「マーケティング」を参照）のためにそれを利用することができます。
    </p>
    <p>
      SPGIは、個人情報保護法第27条第2項に基づき、オプトアウト手続き通知書を個人情報保護委員会に提出しました。S&Pグローバル・マーケット・インテリジェンスでは、お客様が個人データの提供をオプトアウトしない限り、SPGIはオプトアウト手続きに基づいてお客様の個人データを第三者に提供します。
      当該個人情報の提供の詳細（オプトアウトの方法を含む）は以下の通りです。
    </p>
    <h3 class="privacy-h3">S&Pグローバル・マーケット・インテリジェンスがお客様の情報をどのように処理するか（お客様の情報の収集、利用、保存方法を含む）を理解するため、本プライバシーに関する通知をご確認ください。
    </h3>
    <p></p>
    <p>S&Pグローバル・マーケット・インテリジェンスがデータの正確性を維持し、お客様の管轄区域のデータプライバシー法を遵守することを確実にするため：</p>
    <ul>
      <li>ご自身の情報を確認することをお勧めします。お客様の情報を更新するには、下記「<strong>お客様の情報とオプトアウト</strong>」のリンクをご利用ください。 </li>
      <li>本プライバシーに関する通知に記載されている方法でお客様の情報を処理しないことを希望される場合は、下記「<strong>お客様の情報とオプトアウト</strong>」に記載されているオプションをご利用ください。 </li>
    </ul>

    <p>本情報保護方針は他の言語に翻訳される場合があります。英語版と他の言語の記載に矛盾がある場合、英語版が優先されます。 </p>
  </div>

  <h3 class="privacy-h3">会社概要</h3>

  <div>
    <p>SPGIの一部門であるS&Pグローバル・マーケット・インテリジェンス（S&P Global Market Intelligence）（本社所在地：55 Water Street, New York, NY 10041,
      United States、社長兼最高経営責任者：Martina
      Cheung）およびその関連会社は、本プライバシーに関する通知において「<strong>S&P
        グローバル・マーケット・インテリジェンス</strong>」、「<strong>弊社</strong>」、「<strong>弊社</strong>」または「<strong>弊社</strong>」と総称し
      ます。

    </p>
    <p>SPGI（NYSE:
      SPGI）は、不可欠な情報を提供します。弊社は、政府、企業、個人に対して、確信を持って意思決定が行えるよう、、適切なデータ、専門知識、そしてコネクテッドテクノロジーを提供しています。お客様が新しい投資を評価するのを支援することから、サプライ
      チェーン全体にわたるESGとエネルギー移行を案内することまで、弊社は新しい機会を開拓し、課題を解決し、
      世界の進歩を加速加速させています。
    </p>
    <p>
      弊社は、世界の主要企業の多くから、グローバルな資本市場、商品市場、自動車市場における信用格付け、ベンチマーク、分析、ワークフローソリューションの提供を広く求められています。弊社の提供するあらゆるサービスを通じて、弊社は世界の主要企業が今日と明日の計画を立てるお手伝いをしています。
    </p>
    <p>S&Pグローバル・マーケット・インテリジェンスは、SPGIの事業部門です。SPGIには、他にも以下のような部門があります。S&Pダウ・ジョーンズ指数（S&P Dow Jones
      Indices）、S&Pグローバル・コモディティ・インサイト（S&P Global Commodity Insights）、S&Pグローバル・モビリティ（S&P Global
      Mobility）、S&Pグローバル・レーティング・ジャパン（S&P Global
      Ratings）。SPGIは、S&Pグローバル部門の独立性および客観性に関する方針に従い、各事業部門活動の独立性と客観性を維持するため、各事業部門の活動を相互に分離しています。SPGIのマーケット・インテリジェンス部門（「<strong>SPGMI</strong>」）は、価格評価や指数を含む情報を作成します。SPGMI
      は、自社の価格評価活動と、S&Pグローバル・マーケット・インテリジェンスおよびSPGIの他の事業部門が実施するその他の活動との間に明確な構造的・ビジネス上の分離を維持することで、価格評価および指数の品質、独立性、完全性を保護し、実際の利益相反またはそのように見られる可能性がないことを保証しています。
    </p>
  </div>

  <h3 class="privacy-h3">弊社が収集および処理する情報 </h3>
  <p>
    S&Pグローバル・マーケット・インテリジェンスのデータには、資本市場参加者の情報が含まれています。弊社は、お客様に関する以下の種類の情報の一部または全部を収集および処理することがあります：氏名、年齢、性別、会社関係、電話番号（一般またはビジネス用番号、ファックス番号、携帯電話番号）、ビジネス用メールアドレス、役職および職務、勤務先住所、職務経歴および学歴、職業上の所属、公開および非公開市場への投資、保有資産およびカバレッジ、報酬、インサイダー保有および活動、プロフェッショナル理事会および委員会のメンバーシップ、ソーシャルメディアおよびプロフェッショナルネットワーキングサイトへのリンク。弊社が保有するお客様に関する情報を閲覧するには、以下の「<strong>お客様の権利</strong>」セクションの指示に従ってください。
  </p>

  <h3 class="privacy-h3">弊社によるお客様の情報の収集と利用方法 </h3>
  <p>弊社は、以下の情報源から情報を収集しています。 </p>

  <ul>
    <li>弊社の調査部門は、通常、公開されている情報源（プロフェッショナルネットワークのウェブサイト、その他のウェブサイト、公開された規制当局への提出書類、公開されたニュースソースで公開されているコンテンツを含む）を使用しています。
    </li>
    <li>グローバルな資本市場コミュニティにおけるお客様のビジネスパートナー、弊社のお客様の従業員などから収集します。
    </li>
    <li>皆さまのウェブサイト、または </li>
    <li>皆さままたは皆さまの従業員との会話 </li>
  </ul>

  <p>弊社は、第三者からお客様の情報を収集する際に、この法律に基づく関連規定を遵守します。
    公開情報源を利用する際には、本プライバシーに関する通知に記載された目的に必要な情報のみを収集し、かかる情報源から収集したすべての情報について確認および検証を行います。
  </p>
  <p>弊社は、S&Pグローバル・マーケット・インテリジェンスのデータを編集するために情報を処理します。その後、弊社の製品およびサービスをライセンス供与している顧客（お客様の管轄区域内外の両方）にデータを販売します。 </p>
  <p>弊社は、情報に基づいて以下の目的のために皆さまに連絡する場合があります。 </p>
  <ul>
    <li>公開情報から収集した皆さまの情報を検証するため </li>
    <li>弊社のお客様に代わって、お客様から情報を取得します。例えば、お客様が勤務先を代表して参加されている資本市場取引に関連するコンプライアンス証明書などです。 </li>
  </ul>

  <p>弊社は、他国の個人情報保護法を含む適用法に従って、お客様の情報を処理することが求められる場合があります。 </p>

  <h3 class="privacy-h3">お客様の情報を共有および保管する方法</h3>
  <p>前述の通り、弊社は、弊社の製品を通じて、お客様の情報を共有またはライセンス供与する場合があります（前述の「<strong>弊社が収集および処理する情報</strong>」のセクションに記載）。 </p>
  <ol>
    <li>利用目的<br>
      弊社は、グローバル資本市場コミュニティ（金融機関）で働く個人のビジネス連絡先などの個人情報を含む企業データを取得し、お客様に提供しています。これらのデータは、お客様が取引先とのビジネス上のコミュニケーションや情報交換を円滑に行うために利用されています。
    </li>
    <li>個人情報が提供される組織<br>
      弊社のお客様：主に金融機関（投資運用会社、投資銀行、商業銀行、公共および民間
      企業、保険会社、プライベート・エクイティ会社、専門サービス会社、学術機関、政府機関、規制当局など）

    </li>
    <li>第三者への提供方法<br>
      加入者専用のウェブベースのサービスおよびダウンロード可能な構造化ファイル
      （データフィードとも呼ばれる）を通じて。]
    </li>
  </ol>
  <p>
    このようなお客様の情報の共有は、本プライバシーに関する通知に従って行われ、弊社は、お客様の情報をその他の目的で使用することについてお客様の同意を得ている場合を除き、かかる第三者が本プライバシーポリシーに準拠した方法でのみお客様の情報を使用することを義務付ける取り決めを締結するために合理的な努力を払います。
  </p>
  <p>お客様が下記「<strong>お客様の情報とオプトアウト</strong>」の指示に従ってオプトアウトの依頼を弊社に通知した場合、弊社は、上記のような使用目的でお客様の情報を第三者に提供することを停止します。
    また、お客様は、お客様が連絡を受け取っている第三者に対して、お客様の情報の処理を停止し、そのマーケティングまたはその他の連絡からオプトアウトするよう依頼することもできます。弊社は、第三者のデータプライバシーポリシー、行為、または不作為について、一切の責任を負いませんのでご了承ください。
  </p>
  <p>
    前述の通り、お客様の情報を弊社のリソースに保存し、お客様の情報を第三者と共有し、または第三者にお客様の情報をライセンス供与する場合、お客様の管轄外に情報が転送される可能性があります。皆さまの情報が皆さまの法的管轄権の外部に転送された場合、弊社は、かかる転送が皆さまの法的管轄権における妥当なデータ保護法に準拠するよう、妥当な保護基準を設けます。データの移転が中華人民共和国の適用データ保護法（個人情報保護法）の対象となる場合、中国標準契約が適用されます。「中国標準契約」とは、2023年2月24日に中国サイバースペース管理局が発行した「個人情報の国境を越えた移転に関する標準契約」を意味します。
  </p>
  <h3 class="privacy-h3">弊社からお客様へのダイレクトマーケティングコミュニケーション </h3>
  <p>弊社は、お客様の情報を以下のマーケティングおよびプロモーション目的で使用することがあり
    ます。
  </p>
  <ul>
    <li>弊社の製品およびサービス（金融サービス技術、データ、分析、ソフトウェアソリューションなど）に関する最新ニュース、オファー、プロモーションについてお客様に連絡すること、および </li>
  </ul>
  <ul>
    <li>お客様の組織やビジネスに関心があると思われる製品関連のニュースやダイレクトマーケティングのコミュニケーションをお客様に送信すること。

    </li>
  </ul>
  <p>弊社は、このようなダイレクトマーケティングの目的で、電子メール、郵便、または電話にてお客様にご連絡することがあります。 </p>
  <p>これらのダイレクトマーケティングに関する連絡の受け取りを拒否する場合は、下記「<strong>お客様の情報とオプトアウト</strong>」の指示に従ってください。 </p>
  <p>ダイレクトマーケティングの受け取りを拒否した場合でも、弊社は以下を行うことがあります。 </p>
  <ul>
    <li>お客様が弊社からのマーケティング通信を今後一切受け取らないことを保証するために情報を処理する必要があること、および
    </li>
    <li>お客様が弊社の製品およびサービスを継続的にご利用いただく上で、重要な管理上のメッセージをお送りすること。 </li>
  </ul>

  <p></p>
  <h3 class="privacy-h3">お客様の情報のセキュリティと保持 </h3>
  <p>
    弊社は、法律上、業務上、または契約上の目的で合理的に必要とする限り、お客様の情報を保持します。データ保持期間は、地域法、契約上の義務、弊社の妥当なビジネス要件、皆さまの期待および要件などを考慮して決定されます。皆さまの情報保持の目的が達成され、皆さまの情報が不要になった場合には、弊社は情報を安全に削除するか、廃棄いたします。なお、弊社は、適用法および規則を遵守するために、お客様の情報を保持する必要がある場合があり、また、場合によっては、お客様の情報を削除することが技術的に不可能な場合があることにご注意ください（お客様の情報が弊社の内部アーカイブ記録に含まれている場合など）。
  </p>
  <p>
    かかる場合、皆さまの情報保護については万全な対策を施します。弊社は、お客様の情報を、不正使用、不正アクセス、開示、改ざん、破棄から保護し、安全を確保するために、合理的な組織的、技術的、管理上の対策を講じてます。弊社は弊社の担当者に対し、本方針に基づく合法的ビジネスのニーズを満足するためのみの目的で、皆さまの情報にアクセスし使用する許可を与えており
    ます。
  </p>

  <h3 class="privacy-h3">お客様の権利 </h3>
  <p>
    お客様には、弊社がお客様に関して処理する情報にアクセスする権利、弊社がその情報を修正または変更することを要求する権利（不正確または不完全であると判断した場合）、または削除することを要求する権利（弊社がその情報を保持する権利を有していないと判断した場合）、および法律に基づいて付与される権利があります。また、お客様は、特定の状況下でデータが処理されること、およびデータポータビリティ（お客様の情報を他の場所に移動すること）に異議を申し立てる権利も有します。これらの権利は、一部のケースでは適用されない場合があり、お客様が要求した場合、その場合はその旨をお知らせいたします。権利を行使したい場合は、<a
      href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>に書面による依頼を提出してください。 </p>
  <p>弊社は、お客様の情報の処理に関して受け取った苦情や紛争を調査し、解決するよう努めます。
    皆さまは、皆さまの地域データ保護機関に苦情を申し立てる権利を有します。お客様の情報へのアクセス、訂正、修正、または削除を希望される場合は、以下の「<strong>お客様の情報とオプトアウト</strong>」の指示に従ってください。

  </p>

  <h3 class="privacy-h3">お客様の情報とオプトアウト </h3>
  <p>
    お客様の情報へのアクセス、訂正、修正、第三者への情報提供の停止、電子メールによる連絡の購読または停止、停止の選択の修正、またはお客様の情報削除の依頼については、03-6262-1790（日本国内からの電話）または1-800-447-2273、<a
      href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>.</p>
  <p>
    いずれかの選択肢からオプトアウトした場合、弊社がすでにお客様の情報を共有している第三者機関のデータからお客様の情報を削除できない場合があり、また、お客様が弊社からの今後のマーケティング通信を受け取らないことを確実にするために、限定的な情報の処理が必要となる場合があります。
  </p>

  <h3 class="privacy-h3">情報の更新と正確性の維持方法 </h3>
  <p>
    弊社は、お客様の情報更新のご要望にお応えします。弊社は、上記「<strong>お客様のビジネス連絡先情報の収集および使用方法</strong>」に従ってお客様の情報を収集することにより、お客様の情報を正確かつ最新の状態に保つよう努めます。新しい情報は既存の情報と統合され、古い情報や誤った情報は削除されます。
  </p>

  <h3 class="privacy-h3">情報の提供を開始した時期 </h3>
  <p>弊社は、オプトアウト手続きに基づく個人データの提供を2024年5月17日に開始しました。

  </p>

  <h3 class="privacy-h3">弊社への連絡方法

  </h3>
  <p>お客様からのご質問、ご意見、フィードバックは弊社にとって非常に重要です。プライバシー関連の問題やご質問については、 <a
      href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a> までお問い合わせください。</p>
  <p>こに記載された以外の目的で収集した個人情報の取り扱いに関する弊社の一般原則については、以下をご覧ください。<a target="_blank"
      href="https://www.spglobal.com/en/privacy/privacy-policy-english#personal-information-we-collect">グローバル企業プライバシーポリシー</a>
  </p>

  <p>更新日：2025年3月1日</p>
</div>